// Teacher "My students" page.
const en = {
  teacherStudents: {
    title: "My students",
    subtitle: "{{count}} students in your lessons and classes.",
    search: "Search a student, parent or class…",
    empty: "You have no students yet. They appear here once a lesson or class is planned.",
    noMatch: "No student matches your search.",
    parent: "Parent: {{name}}",
    nextLesson: "Next lesson",
    lessonsDone: "Lessons done",
    none: "Not planned",
    writeParent: "Write to the parent",
    homework: "Homework",
  },
};

const fr = {
  teacherStudents: {
    title: "Mes élèves",
    subtitle: "{{count}} élève(s) dans vos cours et vos classes.",
    search: "Rechercher un élève, un parent ou une classe…",
    empty: "Vous n'avez pas encore d'élèves. Ils apparaissent ici dès qu'un cours ou une classe est prévu.",
    noMatch: "Aucun élève ne correspond à votre recherche.",
    parent: "Parent : {{name}}",
    nextLesson: "Prochain cours",
    lessonsDone: "Cours faits",
    none: "Non prévu",
    writeParent: "Écrire au parent",
    homework: "Devoirs",
  },
};

const ar = {
  teacherStudents: {
    title: "تلاميذي",
    subtitle: "{{count}} تلميذ في حصصك وأقسامك.",
    search: "ابحث عن تلميذ أو وليّ أمر أو قسم…",
    empty: "ليس لديك تلاميذ بعد. يظهرون هنا عند برمجة حصة أو قسم.",
    noMatch: "لا يوجد تلميذ يطابق بحثك.",
    parent: "وليّ الأمر: {{name}}",
    nextLesson: "الحصة القادمة",
    lessonsDone: "الحصص المنجزة",
    none: "غير مبرمجة",
    writeParent: "مراسلة وليّ الأمر",
    homework: "الواجبات",
  },
};

const teacherStudentsTranslations = { en, fr, ar };

export default teacherStudentsTranslations;
